import { GlyphSize, GlyphColor } from 'components/Glyph';
import { TextColor } from 'components/Text';

export default {
  ACTIVE_GLYPH_COLOR: 'brand' as GlyphColor,
  COLOR: 'thunder' as TextColor,
  GLYPH_COLOR: 'eclipse' as GlyphColor,
  GLYPH_SIZE: 'large' as GlyphSize,
};
